<h2 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Configure Form Grid
</h2>
<mat-dialog-content>

    <kendo-grid [kendoGridBinding]="this.ColumnDefs"
                [rowReorderable]="true"
                [resizable]="true"
                (rowReorder)="handleRowReorder($event)">
        <kendo-grid-rowreorder-column [width]="7"></kendo-grid-rowreorder-column>
        <kendo-grid-column field="name" title="Column" width=50></kendo-grid-column>
    </kendo-grid>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="primary" class="theme-primary-btn" (click)="closeDialog(true)">
        OK
    </button>

    <button mat-flat-button (click)="closeDialog()">
        Cancel
    </button>
</mat-dialog-actions>
